export const GET_RECIPE_INFO = 'GET_RECIPE_INFO';
export const SET_RECIPE_NUMBER = 'SET_RECIPE_NUMBER';
export const GET_SUITABLE_MEDICATIONS = 'GET_SUITABLE_MEDICATIONS';
export const CHECK_PROVISION = 'CHECK_PROVISION';
export const APPLY_RECIPE = 'APPLY_RECIPE';
export const GET_RXGATE_CURRENT_RECEIPT = 'GET_RXGATE_CURRENT_RECEIPT';
export const SET_RXGATE_CHOSEN_RECEIPT = 'SET_RXGATE_CHOSEN_RECEIPT';
